export default function TabButton({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      className={`rounded-full px-3 py-1.5 font-medium border ${active ? "bg-white border-slate-300" : "bg-slate-50 border-slate-200"}`}
    >
      {children}
    </button>
  );
}